const driverInstance = ref();
const isRunning = ref(false)

const preventEscapeKey = (event: KeyboardEvent) => {
  if (event.key !== "Escape") return;

  event.preventDefault();
  event.stopImmediatePropagation();
};

const enableEscapeKeyPrevention = () => {
  if (typeof window === "undefined") return;

  window.addEventListener("keydown", preventEscapeKey, true);
  window.addEventListener("keyup", preventEscapeKey, true);
};

const disableEscapeKeyPrevention = () => {
  if (typeof window === "undefined") return;

  window.removeEventListener("keydown", preventEscapeKey, true);
  window.removeEventListener("keyup", preventEscapeKey, true);
};

export const useDriverTutorial = () => {
  const driverComposable = useDriver("tutorial");

  const initializeTutorial = (steps: any[]) => {
    if (driverInstance.value) {
      driverInstance.value.destroy();
    }
    driverInstance.value = driverComposable.driver({
      allowClose: false,
      allowKeyboardControl: false,
      overlayClickBehavior: () => {},
      disableActiveInteraction: false,
      popoverClass: "driverjs-theme",
      steps,
      onDestroyed: () => {
        driverInstance.value = null;
        disableEscapeKeyPrevention();
      },
    });
  };

  const startTutorial = () => {
    if (driverInstance.value) {
      enableEscapeKeyPrevention();
      driverInstance.value.drive();
      isRunning.value = true;
    }
  };

  const closeTutorial = () => {
    if (driverInstance.value) {
      driverInstance.value.destroy();
    }
    isRunning.value = false;
    disableEscapeKeyPrevention();
  };

  const nextStep = () => {
    driverInstance.value?.moveNext();
  };

  const prevStep = () => {
    driverInstance.value?.movePrevious();
  };

  return {
    driverInstance,
    isRunning,
    initializeTutorial,
    startTutorial,
    closeTutorial,
    nextStep,
    prevStep,
  };
};
